import type { MindMapDocument } from '@/model/document';
import { debounce } from '@/utils/debounce';
import { saveMap } from '@/persistence/hybridPersistence';
import { useEditorStore } from '@/store/editorStore';

/**
 * Observes a MindMapDocument for changes and autosaves via the hybrid
 * persistence layer (cloud when authenticated, IndexedDB otherwise)
 * with a 1-second debounce. Returns a cleanup function to stop observing.
 */
export function startAutosave(mapDoc: MindMapDocument, mapId: string): () => void {
  const save = debounce(() => {
    const title = mapDoc.getMeta().title;
    useEditorStore.getState().setSaveStatus('saving');
    saveMap(mapDoc, mapId, title)
      .then(() => {
        useEditorStore.getState().setSaveStatus('saved');
      })
      .catch(() => {
        useEditorStore.getState().setSaveStatus('error');
      });
  }, 1000);

  const unobserve = mapDoc.observe(() => {
    save();
  });

  return () => {
    save.cancel();
    unobserve();
  };
}
